import './css/header.css';
import headerPhoto from '../photos/header.png';
import {useNavigate } from 'react-router-dom';
export default function Header(){

  const navigate = useNavigate();
    return(
        <header>
        <div className="header-content">
          <h1>  <span style={{color:'black'}}> Great </span> <span className="perpel-color">Product </span>
          <span style={{color:'black' 
           }}> is </span> 
          <br></br> 
          built by great
          <span className="perpel-color"> teams </span> </h1>
          <p>We help bulid and manage your site by a team of world-class developers <br></br>
            to bring your vision to life.<br></br>
            
          </p>

          <button onClick={()=>navigate('/about-us')}>Let's Start</button>

        </div>
        <div className="header-photo">
        <img src = {headerPhoto} className ="header" alt ="Logo Navbar"/>

        </div>
      </header>

    );
}